(() => {
  const element = document.getElementById('sm-delivery-config');
  if (!element || document.documentElement.dataset.smMarketReady) return;
  document.documentElement.dataset.smMarketReady = 'true';
  const config = JSON.parse(element.textContent);
  let interacted = false;
  let pending = false;
  let detection;
  let releaseTimer;
  const valid = code => Object.hasOwn(config.countries, code || '');
  const savedCountry = () => {
    for (const storage of ['localStorage','sessionStorage']) {
      try { const code=window[storage].getItem('smylume-delivery-manual-country'); if (valid(code)) return code; } catch {}
    }
    return null;
  };
  const pauseDetection = () => { interacted=true; detection?.abort(); };
  const remember = code => {
    pauseDetection();
    if (!valid(code)) return;
    for (const storage of ['localStorage','sessionStorage']) {
      try { window[storage].setItem('smylume-delivery-manual-country',code); } catch {}
    }
  };
  const render = code => {
    if (!valid(code)) return;
    const days=Math.ceil(config.rates[code]??12);
    const text=template=>template.replace('__MIN__',days+1).replace('__MAX__',days+3).replace('__COUNTRY__',config.countries[code]);
    document.querySelectorAll('[data-sm-delivery-range]').forEach(node=>{node.textContent=text(config.range);});
    document.querySelectorAll('[data-sm-delivery-cart-range]').forEach(node=>{node.textContent=text(config.cartRange);});
    document.querySelectorAll('[data-sm-delivery-select]').forEach(node=>{node.value=code;});
    document.querySelectorAll('[data-sm-delivery-row]').forEach(node=>{node.dataset.smDeliveryActive=String(node.dataset.smDeliveryRow===code);});
  };
  const preserveSelection = () => {
    const root=document.getElementById('sm-kits');
    const node=root?.querySelector('[data-four-offer-config]');
    if (!root || !node) return;
    const product=JSON.parse(node.textContent);
    const selected=[...root.querySelectorAll('[name="sm-kit"]:checked')].map(input=>input.value);
    const colours=Object.fromEntries([...root.querySelectorAll('[data-card-colour]:checked')].map(input=>[input.dataset.cardColour,input.value]));
    const addons=[...root.querySelectorAll('[data-addon]:checked')].map(input=>input.dataset.addon);
    const addonColours=Object.fromEntries([...root.querySelectorAll('select[data-addon-colour]')].map(input=>[input.dataset.addonColour,input.value]));
    try { sessionStorage.setItem('smylume-market-selection',JSON.stringify({productId:String(product.nativeProductId),selected,colours,addons,addonColours,created:Date.now()})); } catch {}
  };
  const returnPath = form => {
    const value=location.pathname+location.search+location.hash;
    let input=form.querySelector('[name="return_to"]');
    if (!input) { input=document.createElement('input');input.type='hidden';input.name='return_to';form.append(input); }
    input.value=value;
  };
  const setBusy = (form,busy) => {
    form.toggleAttribute('aria-busy',busy);
    form.querySelectorAll('button[name="country_code"],a[data-value]').forEach(button=>{
      if (busy) button.setAttribute('aria-disabled','true'); else button.removeAttribute('aria-disabled');
    });
    const picker=form.querySelector('.sm-country-picker');
    if (picker && busy) picker.open=false;
    form.classList.toggle('sm-market-changing',busy);
  };
  const localize = code => {
    if (!valid(code) || code===config.country || pending || interacted || savedCountry()) return;
    const form=document.createElement('form');form.method='post';form.action=(window.Shopify?.routes?.root||'/')+'localization';form.hidden=true;
    for (const [name,value] of Object.entries({form_type:'localization',utf8:'✓',_method:'put',country_code:code})) {
      const input=document.createElement('input');input.type='hidden';input.name=name;input.value=value;form.append(input);
    }
    returnPath(form);document.body.append(form);pending=true;form.submit();
  };
  document.addEventListener('pointerdown',pauseDetection,{capture:true,once:true});
  document.addEventListener('keydown',pauseDetection,{capture:true,once:true});
  document.addEventListener('touchstart',pauseDetection,{capture:true,once:true,passive:true});
  document.addEventListener('focusin',event=>{if(event.target.closest('form[action*="/localization"]'))pauseDetection();});
  document.addEventListener('toggle',event=>{if(event.target.matches('.sm-country-picker')&&event.target.open)pauseDetection();},true);
  document.addEventListener('click',event=>{
    const target=event.target.closest('button[name="country_code"],localization-form a[data-value]');
    if (!target) return;
    const code=target.value||target.dataset.value;
    if (!valid(code)) return;
    if (pending) { event.preventDefault();event.stopImmediatePropagation();return; }
    remember(code);
    if (code===config.country) { event.preventDefault();event.stopImmediatePropagation();target.closest('details')?.removeAttribute('open');return; }
    const form=target.closest('form');
    if (form) {
      returnPath(form);preserveSelection();
      if(target.matches('a[data-value]')){
        pending=true;setBusy(form,true);
        clearTimeout(releaseTimer);releaseTimer=setTimeout(()=>{pending=false;setBusy(form,false);},10000);
      }
    }
  },true);
  document.addEventListener('change',event=>{
    if (!event.target.matches('[data-sm-delivery-select]')) return;
    const code=event.target.value;remember(code);
    if (code===config.country || pending) return;
    event.target.form.requestSubmit();
  });
  document.addEventListener('submit',event=>{
    const form=event.target;
    if (!form.matches('form[action*="/localization"]')) return;
    const submitter=event.submitter;
    const code=submitter?.name==='country_code'?submitter.value:form.querySelector('[name="country_code"]')?.value;
    if (!valid(code)) return;
    if (pending || code===config.country) {event.preventDefault();return;}
    remember(code);returnPath(form);preserveSelection();pending=true;setBusy(form,true);
    clearTimeout(releaseTimer);releaseTimer=setTimeout(()=>{pending=false;setBusy(form,false);},10000);
  },true);
  window.addEventListener('pageshow',()=>{
    pending=false;clearTimeout(releaseTimer);
    document.querySelectorAll('form.sm-market-changing').forEach(form=>setBusy(form,false));
  });
  render(config.country);
  if (savedCountry()) return;
  try {if(sessionStorage.getItem('smylume-market-auto-checked'))return;sessionStorage.setItem('smylume-market-auto-checked','1');} catch {return;}
  detection=new AbortController();
  const timeout=setTimeout(()=>detection.abort(),5000);
  fetch((window.Shopify?.routes?.root||'/')+'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false',{credentials:'same-origin',signal:detection.signal})
    .then(response=>response.ok?response.json():null)
    .then(data=>{if(!interacted&&!pending&&!savedCountry())localize(data?.detected_values?.country?.handle);})
    .catch(()=>{})
    .finally(()=>clearTimeout(timeout));
})();
